/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { IconDotsVertical, IconPlus } from "@tabler/icons-react";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import { useNavigate } from "react-router-dom";
import ToggleButton from "../../../components/ToggleButton";
import {
  useFetchRoutesData,
  useRouteStatusMutation,
} from "../../../apis/routeApis";
import formatDate from "../../../utilities/helper";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import useDebounce from "../../../utilities/useDebounce";
import Pagination from "../../../components/common/Pagination";
import MessageModal from "../../../components/MessageModal";
import toast from "react-hot-toast";
import AssignDriversModal from "./AssignDriversModal";
import NoDataFound from "../../../components/common/NoDataFound";
import ViewDistrictModal from "./ViewDistrictModal";

const RouteListManagement = () => {
  const navigate = useNavigate();
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [activeModal, setActiveModal] = useState<boolean>(false);
  const [status, setStatus] = useState<string>("");
  const [id, setId] = useState<string>("");
  const { mutate: statusMutate, isPending: isStatusPending } =
    useRouteStatusMutation(id);
  const {
    data: routes,
    isPending: listPending,
    isFetching,
    refetch,
  } = useFetchRoutesData(pageNo, limit, searchFor);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo, limit]);

  const updateStatus = () => {
    statusMutate(
      { status: status === "ACTIVE" ? "INACTIVE" : "ACTIVE" },
      {
        onSuccess: (data: any) => {
          setActiveModal(false);
          refetch();
        },
        onError: (error: any) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdownIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedRouteId, setSelectedRouteId] = useState<string | null>(null);
  const [districtModalOpen, setDistrictModalOpen] = useState(false);
  const [selectedRouteDistricts, setSelectedRouteDistricts] = useState<
    string[]
  >([]);

  return (
    <>
      <div className="">
        <div className="rounded-3xl bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]">
          <div className="flex items-start">
            <div className="  flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[30px] ">
              <h1 className="text-lg font-medium text-[#212121]">
                Route Lists
              </h1>
              <div className="flex items-center gap-2">
                <NormalSearch
                  value={searchFor}
                  onChange={(e) => {
                    setSearchFor(e.target.value);
                    setPageNo(1);
                  }}
                />
                <button
                  onClick={() => navigate(`/route-add`)}
                  className="bg-[#FBD037] text-[#212121] text-sm font-semibold p-2 rounded-full"
                >
                  <IconPlus stroke={1.5} size={24} />
                </button>
              </div>
            </div>
          </div>{" "}
          {listPending ? (
            <TableSkeleton
              mainClass="bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]"
              subClassName=""
              columns={[
                "S/N",
                "Route Code",
                "Route Name",
                "City",
                "District",
                "Created On",
                "Status",
                "Actions",
              ]}
              rows={6}
            />
          ) : routes?.routes?.length ? (
            <ListView
              tdClassName="rounded-r-none rounded-l-none"
              trClassName="hover:bg-[#FBD037]/20"
              mainDivClassName=" rounded-b-3xl bg-transparent"
              mailDivClassName="p-0 bg-transparent rounded-r-none rounded-br-3xl rounded-b-3xl"
              thClassName="border-t"
              data={routes?.routes}
              columns={[
                {
                  label: "#",
                  render: (_: any, i: number) => (pageNo - 1) * limit + (i + 1),
                },
                { label: "Route Code", render: (c: any) => c.routeCode },
                {
                  label: "Route Name",
                  render: (c: any) => c.routeName,
                },
                { label: "City", render: (c: any) => c.cityName },
                {
                  label: "District",
                  render: (c: any) => ( 
                    <button
                      className="text-blue-600 underline text-sm"
                      onClick={() => {
                        setSelectedRouteDistricts(c.districtNames);
                        setDistrictModalOpen(true);
                      }}
                    >
                      View
                    </button>
                  ),
                },
                {
                  label: " Created On",
                  render: (c: any) => formatDate(c.createdAt),
                },
                {
                  label: "Status",
                  render: (c: any) => (
                    <div className=" flex justify-center items-center">
                      <ToggleButton
                        onChange={() => {
                          setId(c?.id);
                          setStatus(c?.status);
                          setActiveModal(true);
                        }}
                        checked={c?.status === "ACTIVE"}
                      />
                    </div>
                  ),
                },
                {
                  label: "Actions",
                  render: (c: any) => (
                    <div className="relative flex justify-center">
                      <button
                        onClick={() =>
                          setOpenDropdownIndex(
                            openDropdownIndex === c ? null : c
                          )
                        }
                        className="p-2 border rounded-full bg-[#F7F6F2]"
                      >
                        <IconDotsVertical size={20} />
                      </button>

                      {openDropdownIndex === c && (
                        <div
                          ref={dropdownRef}
                          className="absolute bg-[#F7F6F2] divide-y divide-[#979797]/50 right-20 w-24 -top-10 z-50 mt-2   rounded-xl shadow-lg overflow-hidden"
                        >
                          <div
                            onClick={() => navigate(`/route-assign/${c.id}`)}
                            className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                          >
                            View
                          </div>
                          <div
                            onClick={() => {
                              setSelectedRouteId(c.id);
                              setAssignModalOpen(true);
                              setOpenDropdownIndex(null);
                            }}
                            className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                          >
                            Assign
                          </div>
                        </div>
                      )}
                    </div>
                  ),
                },
              ]}
            />
          ) : (
            <NoDataFound
              subClassName=""
              mainClassName="bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] rounded-b-3xl"
            />
          )}
          {routes?.totalPages > 1 && (
            <div className="flex justify-center items-center py-4">
              <Pagination
                currentPage={pageNo}
                totalPages={routes?.totalPages}
                fetchData={handlePaginationFetch}
              />
            </div>
          )}
        </div>
      </div>
      {assignModalOpen && (
        <AssignDriversModal
          open={assignModalOpen}
          onClose={() => setAssignModalOpen(false)}
          routeId={selectedRouteId}
        />
      )}

      {districtModalOpen && (
        <ViewDistrictModal
          open={districtModalOpen}
          onClose={() => setDistrictModalOpen(false)}
          districtItems={selectedRouteDistricts}
        />
      )}

      <MessageModal
        open={activeModal}
        onClose={() => setActiveModal(false)}
        title="Confirmation Required"
        subtitle="Are you sure you want to perform this action?"
        img={status === "ACTIVE" ? "/img/inactive.svg" : "/img/active.svg"}
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        actionButtonOnClick={updateStatus}
        isPending={isStatusPending}
        size="md"
      />
    </>
  );
};

export default RouteListManagement;
